<template>
  <v-text-field
    :disabled="disabled"
    :hint="hint"
    :rules="ruleList"
    outlined
    v-model="value"
  ></v-text-field>
</template>

<script>
import formElementMixin from "./formElementMixin";

export default {
  mixins: [formElementMixin],
  props: {
    hint: {
      type: String,
    },
  },
};
</script>
